import React, {useState} from 'react';

// Aws Data Store and Model
import { DataStore } from 'aws-amplify';
import { Farbe } from '../models';

// React Router
import { useNavigate, useParams } from 'react-router';

import FormControl from '@mui/material/FormControl';
import Button from '@mui/material/Button';
import { Box } from '@mui/system';
import Input from '@mui/material/Input';
import InputLabel from '@mui/material/InputLabel';

// Create a New Color function
function onCreate() {
    DataStore.save(
        new Farbe ({
            name:"",
        })
    );
}

export default function ColorForm() {

    const [ color, setColor ] = React.useState('');
    const {id} = useParams();
    const [fadeIn, setFadeIn] = useState(false);
    const navigate = useNavigate();

    React.useEffect(() => {
        fetchColors();
        async function fetchColors() {
            const color = await DataStore.query(Farbe);
            setColor(color)
        }
    }, [id]);

    const [name, setName] = useState('');

    async function saveColor() {
        const tempColor = new Farbe({
            name:name,
        });
        await DataStore.save(tempColor);
    }

    function handleChange(event) {
        console.log(event.target.value);
    }

    const handleSubmit = (event) => {
        event.preventDefault();
        saveColor().then((data) => {
            setFadeIn(true);
            setTimeout(() => {
                navigate('/', {replace: true});
            }, 1500);
        });
    }

    return (
        <form>
            <Box>
            <FormControl variant="standard" style={{width:'100%'}}>
                <InputLabel htmlFor="component-simple" style={{color:'#E30015'}}>Name</InputLabel>
                <Input
                    style={{borderBottom:'2px solid white', width:'100%'}}
                    id="name"
                    name="name"
                    value={name}
                    onChange={(event) => setName(event.target.value)}
                />
            </FormControl>
            </Box>
            <Box style={{marginTop:'20px'}}>
                <Button 
                    onClick={handleSubmit}
                    style={{backgroundColor:'#E30015', color:'white', fontWeight:'700'}}
                >
                    Speichern
                </Button>
            </Box>
        </form>
    )
}
